import React from 'react'
import "./ServiceCard.scss"

const ServiceCard = ({serv_img,serv_header,serv_description}) => {
  return (
    
    <div className='service-card-box'>
      <img src={serv_img} alt="" draggable="false"/>
      <div className="card-text">
      <h1>{serv_header}</h1>
      <p>{serv_description}</p>
      </div>
      
    </div>
   
    
    
  )
}

export default ServiceCard
